"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCampaignRequestToJSON = exports.CreateCampaignRequestFromJSONTyped = exports.CreateCampaignRequestFromJSON = exports.instanceOfCreateCampaignRequest = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var CampaignChannel_1 = require("./CampaignChannel");
var DeliveryGoalGroup_1 = require("./DeliveryGoalGroup");
var MeasurementPartners_1 = require("./MeasurementPartners");
var OptimizationPrefs_1 = require("./OptimizationPrefs");
/**
 * Check if a given object implements the CreateCampaignRequest interface.
 */
function instanceOfCreateCampaignRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "objective" in value;
    return isInstance;
}
exports.instanceOfCreateCampaignRequest = instanceOfCreateCampaignRequest;
function CreateCampaignRequestFromJSON(json) {
    return CreateCampaignRequestFromJSONTyped(json, false);
}
exports.CreateCampaignRequestFromJSON = CreateCampaignRequestFromJSON;
function CreateCampaignRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'purchaseOrder': !(0, runtime_1.exists)(json, 'purchase_order') ? undefined : json['purchase_order'],
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsFromJSON)(json['objective']),
        'spaaPixelId': !(0, runtime_1.exists)(json, 'spaa_pixel_id') ? undefined : json['spaa_pixel_id'],
        'measurementPartner': !(0, runtime_1.exists)(json, 'measurement_partner') ? undefined : (0, MeasurementPartners_1.MeasurementPartnersFromJSON)(json['measurement_partner']),
        'channel': !(0, runtime_1.exists)(json, 'channel') ? undefined : (0, CampaignChannel_1.CampaignChannelFromJSON)(json['channel']),
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'salesforceOpportunity': !(0, runtime_1.exists)(json, 'salesforce_opportunity') ? undefined : json['salesforce_opportunity'],
        'salesforceSalesOrder': !(0, runtime_1.exists)(json, 'salesforce_sales_order') ? undefined : json['salesforce_sales_order'],
        'deliveryGoalGroup': !(0, runtime_1.exists)(json, 'delivery_goal_group') ? undefined : (0, DeliveryGoalGroup_1.DeliveryGoalGroupFromJSON)(json['delivery_goal_group']),
    };
}
exports.CreateCampaignRequestFromJSONTyped = CreateCampaignRequestFromJSONTyped;
function CreateCampaignRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'purchase_order': value.purchaseOrder,
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsToJSON)(value.objective),
        'spaa_pixel_id': value.spaaPixelId,
        'measurement_partner': (0, MeasurementPartners_1.MeasurementPartnersToJSON)(value.measurementPartner),
        'channel': (0, CampaignChannel_1.CampaignChannelToJSON)(value.channel),
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'salesforce_opportunity': value.salesforceOpportunity,
        'salesforce_sales_order': value.salesforceSalesOrder,
        'delivery_goal_group': (0, DeliveryGoalGroup_1.DeliveryGoalGroupToJSON)(value.deliveryGoalGroup),
    };
}
exports.CreateCampaignRequestToJSON = CreateCampaignRequestToJSON;
